/**
 * Word/Excel task panes load Office.js, which replaces window.alert / confirm / prompt
 * with stubs that throw. Dependencies that still call alert() then crash the add-in.
 * After Office is present, install console-based shims so the app keeps running.
 */
export function installOfficeDialogShims(): void {
  if (typeof window === "undefined" || typeof Office === "undefined") {
    return;
  }
  window.alert = (message?: string) => {
    console.warn("[IntelliDocSuite]", message ?? "");
  };
  window.confirm = (message?: string) => {
    console.warn("[IntelliDocSuite confirm]", message ?? "");
    return true;
  };
  window.prompt = (message?: string, defaultValue?: string) => {
    void defaultValue;
    console.warn("[IntelliDocSuite prompt]", message ?? "");
    return null;
  };
}
